import React from 'react';

import { FilterContext } from 'src/providers/FilterProvider';

export const useFilter = () => {
  return React.use(FilterContext);
};
